import React from 'react';
import I18n from 'i18n-js';
import { ProductReviewCardFields } from '@reverbdotcom/commons/src/gql/graphql';
import { ProductReviewCard } from './ProductReviewCard';
import { ProductReviewForm } from './ProductReviewForm';
import { SanitizedRender } from '@reverbdotcom/commons';

interface Props {
  reviews: ProductReviewCardFields.Fragment[];
  reviewCount: number;
  cspId: string;
  searchQuery: string;
  trackingDisplayStyle: 'product' | 'csp';
}

export function ProductReviews({
  reviews,
  reviewCount,
  cspId,
  searchQuery,
  trackingDisplayStyle,
}: Props) {
  if (!reviews) {
    return null;
  }

  if (reviewCount === 0) {
    return (
      <ProductReviewForm
        cspId={cspId}
        myReview={null}
        trackingDisplayStyle={trackingDisplayStyle}
        showHeader
      />
    );
  }

  if (reviews.length === 0) {
    return (
      <div className="mtb-8">
        <SanitizedRender
          html={I18n.t('discovery.productReviews.searchInput.zeroResults',
            {
              searchQuery: searchQuery,
            },
          )}
        />
      </div>
    );
  }

  return (
    <div className="scaling-mtb-8 d-flex fx-dir-col gap-8">
      {reviews.map((review) => (
        <ProductReviewCard
          cspId={cspId}
          review={review}
          key={review.id}
          trackingDisplayStyle={trackingDisplayStyle}
        />
      ))}
    </div>
  );
}
